// TODO Replace with tooltip from alembic
import { Tooltip } from '@chakra-ui/tooltip';
import { Children, cloneElement, ReactNode } from 'react';
import useAuthAccessQuery from 'src/hooks/useAuthAccessQuery';

interface Props {
  children: JSX.Element | JSX.Element[];
  relation: string;
  entityType: string;
  entityId: string;
  tooltipLabel?: ReactNode;
}

const ProtectedAction = ({
  children,
  relation,
  entityId,
  entityType,
  tooltipLabel = <span>You do not have permission to make this decision</span>
}: Props) => {
  const { isAllowed, isLoading } = useAuthAccessQuery({
    relation,
    entityType,
    entityId
  });

  return (
    <>
      {isAllowed
        ? children
        : Children.map(children, (child, index) => (
            <Tooltip
              key={index}
              isDisabled={isLoading}
              shouldWrapChildren
              hasArrow
              label={tooltipLabel}
              fontSize="md"
              placement="top"
            >
              {cloneElement(child, {
                isDisabled: true,
                isLoading,
                onClick: (e: Event) => e.preventDefault()
              })}
            </Tooltip>
          ))}
    </>
  );
};

export default ProtectedAction;
